export function toKebabCase(str: string): string {
	return str
		.replace(/([a-z0-9])([A-Z])/g, '$1-$2') // insert hyphen between lowercase/number and uppercase
		.replace(/([A-Z])([A-Z][a-z])/g, '$1-$2') // handle consecutive capitals properly
		.toLowerCase();
}
